import { createSlice } from "@reduxjs/toolkit";

interface RootState {
  authToken: any;
  isAppReady: boolean;
  user_details: object;
  company_details: object;
  orbit_details:any
  tempUserData:object
  user_image:string
  isAdmin:boolean
  isCitizen:boolean
  isVolunteer:boolean
}

const initialState: RootState = {
  authToken:null,
  isAppReady: false,
  user_details: {},
  company_details: {},
  orbit_details:[],
  tempUserData:{},
  user_image:'',
  isAdmin:false,
  isCitizen:false,
  isVolunteer:false,

};

export const authSlice = createSlice({
  name: "authDetails",
  initialState,
  reducers: {
    setAuthToken: (state: any, { payload }) => {
      state.authToken = payload;
      state.isAppReady = true;
    },
    setUserDetails: (state: any, { payload }) => {
      state.user_details = payload;
    },
    setUserImage: (state: any, { payload }) => {
      state.user_image = payload;
    },
    setCompanyDetails: (state: any, { payload }) => {
      state.company_details = payload;
    },
    setOrbitDetails: (state: any, { payload }) => {
      state.orbit_details = payload;
    },
    setTempUserData: (state: any, { payload }) => {
      state.tempUserData = payload;
    },
    setIsAdmin: (state: any, { payload }) => {
      state.isAdmin = payload;
    },
    setIsCitizen: (state: any, { payload }) => {
      state.isCitizen = payload;
    },
    setIsVolunteer: (state: any, { payload }) => {
      state.isVolunteer = payload;
    },
     resetAuthSlice: (state: any) =>  {
         state = {...state, ...initialState}
    },
  },
});

export const { setAuthToken, setUserDetails, setCompanyDetails,setTempUserData ,setOrbitDetails,setUserImage,setIsAdmin,setIsCitizen,setIsVolunteer,resetAuthSlice} = authSlice.actions;

export const getAuthDetails = (state: any) => state.authReducer;
export const getAuthToken = (state: any) => state.authReducer.authToken;
export const getUserDetails = (state: any) => state.authReducer.user_details;
export const getOrbitDetails = (state: any) => state.authReducer.orbit_details;
export const getCompanyDetails = (state: any) => state.authReducer.company_details;
export const getTempUserData = (state: any) => state.authReducer.tempUserData;
export const getUserImage = (state: any) => state.authReducer.user_image;
export const getIsAdmin = (state: any) => state.authReducer.isAdmin;
export const getIsCitizen = (state: any) => state.authReducer.isCitizen;
export const getIsVolunteer = (state: any) => state.authReducer.isVolunteer;


export default authSlice.reducer;
